<script>
import FAQ from "@/components/_Shared/Checkout/FAQ";

export default {
  components: {
    FAQ
  }
};
</script>

<template>
    <div class="container">
        <div class="card">
            <h1 class="title">Ajuda</h1>
            <FAQ></FAQ>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/Help.vue